<template>
  <el-form label-width="140px">
    <el-form-item
      label="Manufacturer"
      required
    >
      <el-select
        v-model="selectedManufacturer"
        class="w-100"
        clearable
        value-key="id"
        :loading="isLoadingManufacturers"
        @change="() => { asset.manufacturer_model = undefined }"
      >
        <el-option
          v-for="manufacturer in manufacturers"
          :key="manufacturer.id"
          :label="manufacturer.label"
          :value="manufacturer"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="Model"
      required
    >
      <el-select
        v-model="asset.manufacturer_model"
        class="w-100"
        value-key="id"
        :disabled="!selectedManufacturer"
      >
        <el-option
          v-for="manufacturerModel in manufacturerModels"
          :key="manufacturerModel.id"
          :label="manufacturerModel.label"
          :value="manufacturerModel"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="Serial Number"
      required
    >
      <el-input
        v-model="asset.serial"
        class="w-100"
      />
    </el-form-item>

    <el-form-item
      label="Branch / Location"
      required
    >
      <el-select
        v-model="event.branch"
        class="w-100"
        clearable
        value-key="id"
        :loading="isLoadingBranches"
      >
        <el-option
          v-for="branch in branches"
          :key="branch.id"
          :label="branch.label"
          :value="branch"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="Attachments">
      <FileUpload
        drag
        multiple
      />
    </el-form-item>
  </el-form>
</template>

<script>
import FileUpload from '@/components/FileUpload'
import { TYPE_CREATED } from '@/plugins/sdk/resources/Asset/Event'

export default {
  components: {
    FileUpload
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoadingManufacturers: false,
      isLoadingBranches: false,
      manufacturers: [],
      branches: [],
      selectedManufacturer: undefined,
      event: Object.assign(new this.$sdk.asset_event(), {
        type: TYPE_CREATED
      }),
      note: new this.$sdk.note()
    }
  },
  computed: {
    manufacturerModels () {
      return (this.selectedManufacturer instanceof this.$sdk.asset_manufacturer ? this.selectedManufacturer.models : [])
    }
  },
  mounted () {
    this
      .event
      .notes
      .push(this.note)

    this
      .asset
      .events
      .push(this.event)

    this.loadManufacturers()
    this.loadBranches()
  },
  methods: {
    async loadManufacturers () {
      this.isLoadingManufacturers = true

      try {
        this.manufacturers = await this
          .$sdk
          .assetmanufacturer
          .list(request => {
            request.include = [ 'models' ]
            request.limit = 100
          })
      } finally {
        this.isLoadingManufacturers = false
      }
    },
    async loadBranches () {
      this.isLoadingBranches = true

      try {
        this.branches = await this
          .$sdk
          .dictionary_businessbranch
          .list(request => {
            request.limit = 100
          })
      } finally {
        this.isLoadingBranches = false
      }
    }
  }
}
</script>
